import React from "react";
import { useState } from "react";
import { fabricToggleColor } from "../../redux/creators/playerCreators";
import styled from "styled-components";
import { ELVA_CLOUDFRONT_URL } from "../../../../constants/elva";
import { useDispatch } from "react-redux";

export default function FabricControlsColorToggle() {
  const dispatch = useDispatch();
  const [state, setState] = useState(true);
  const onClick = () => {
    setState(!state);
    dispatch(fabricToggleColor());
  };
  return (
    <ToggleButton
      className="threekit-option"
      id="threekit-toggleColor"
      onClick={onClick}
    >
      <img src="https://cdn.shopify.com/s/files/1/0591/4299/6149/files/color.png" />
      <img src="https://cdn.shopify.com/s/files/1/0591/4299/6149/files/bw.png" />
      <ActiveArea isColor={state} />
    </ToggleButton>
  );
}

const ToggleButton = styled.button`
  padding: 10px 8px;
  box-sizing: border-box;
  border-radius: 32px;
  position: relative;
  display: flex;
  border: none;
  justify-content: space-between;
  cursor: pointer;
  background: #eaeaea !important;
  gap: 32px;
  > img {
    width: 80px;
    z-index: 2;
    padding-right: 10px;
  };
`;
const ActiveArea = styled.div`
  width: 104px;
  height: 40px;
  background: white;
  display: block !important;
  border-radius: 32px;
  position: absolute;
  z-index: 1;
  margin: 2px 2px;
  transform: scale(0.9);
  top: 0;
  left: ${(props) => (props.isColor ? "0" : "auto")};
  right: ${(props) => (props.isColor ? "auto" : "0")};
`;
